<template>
  <v-dialog
    v-model="$store.state.saisonStore.modalOpen"
    max-width="90%"
  >
    <v-card>
      <v-card-title
        primary-title
        class="text-center primary white--text"
      >
        <v-row>
          <v-col class="py-0">
            Spielbericht
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="pt-1">
        <v-row
          align="center"
          justify="center"
        >
          <v-col cols="8" sm="4" class="title text-center">
            Heimteam
            <br>
            <template v-if="isSpielfrei(this.dialogHeimTeam.name)">
              <span class="font-weight-black">Spielfrei</span>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="2" sm="12" class="pb-0">
                  <v-avatar size="32px">
                    <v-img
                      :src="showLogo(dialogHeimTeam.id)"
                      alt=""
                    />
                  </v-avatar>
                </v-col>
                <v-col cols="10" sm="12" class="title font-weight-black">
                  {{ dialogHeimTeam.name }}
                </v-col>
              </v-row>
            </template>
          </v-col>

          <v-col
            cols="4"
            sm="2"
            class="headline text-center text-sm-right"
          >
            <span v-if="dialogHeimTeam.ergebnis > dialogAuswTeam.ergebnis">
              <b class="green--text">{{ dialogHeimTeam.ergebnis }}</b>
            </span>
            <span v-else-if="dialogHeimTeam.ergebnis < dialogAuswTeam.ergebnis">
              {{ dialogHeimTeam.ergebnis }}
            </span>
            <span v-else>
              {{ dialogHeimTeam.ergebnis }}
            </span>
          </v-col>

          <v-col
            cols="4"
            sm="2"
            class="headline order-2 order-sm-1 text-center text-sm-left"
          >
            <span v-if="dialogHeimTeam.ergebnis > dialogAuswTeam.ergebnis">
              {{ dialogAuswTeam.ergebnis }}
            </span>
            <span v-else-if="dialogHeimTeam.ergebnis < dialogAuswTeam.ergebnis">
              <b class="green--text">{{ dialogAuswTeam.ergebnis }}</b>
            </span>
            <span v-else>
              {{ dialogAuswTeam.ergebnis }}
            </span>
          </v-col>

          <v-col
            cols="8"
            sm="4"
            class="title text-center order-1 order-sm-2"
          >
            Auswärts&shy;team
            <br>
            <template v-if="isSpielfrei(this.dialogAuswTeam.name)">
              <span class="font-weight-black">Spielfrei</span>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="2" sm="12" class="pb-0">
                  <v-avatar size="32px">
                    <v-img
                      :src="showLogo(dialogAuswTeam.id)"
                      alt=""
                    />
                  </v-avatar>
                </v-col>
                <v-col cols="10" sm="12" class="title font-weight-black">
                  {{ dialogAuswTeam.name }}
                </v-col>
              </v-row>
            </template>
          </v-col>
          <v-col cols="12" class="hidden-sm-and-up">
            <v-divider />
          </v-col>
        </v-row>
        <v-row class="hidden-sm-and-up text-center title">
          <v-col cols="12">
            <v-divider />
          </v-col>
          <v-col cols="6">
            Heim-Team
          </v-col>
          <v-col>Ausw.-Team</v-col>
        </v-row>

        <v-row class="d-none d-sm-flex">
          <v-col
            cols="2"
            class="body-2 text-left pl-2"
          >
            Name
          </v-col>
          <v-col
            cols="3"
            v-if="!isSpielfrei(dialogHeimTeam.name) && !checkNil(dialogHeimTeam.players)"
            class="text-center px-0 d-none d-sm-flex"
          >
            Vitalwerte
          </v-col>
          <v-col
            v-else
          >
            -
          </v-col>
          <v-col cols="1" class="px-0 text-center">
            Ergebnis
          </v-col>
          <v-col cols="1" class="px-0 text-center">
            Ergebnis
          </v-col>

          <v-col
            sm3
            v-if="!isSpielfrei(dialogHeimTeam.name) && !checkNil(dialogHeimTeam.players)"
            class="px-0 d-none d-sm-flex text-center"
          >
            Vitalwerte
          </v-col>
          <v-col
            v-else
          >
            -
          </v-col>
          <v-col cols="2" class="body-2 pr-4 pl-0 text-right">
            Name
          </v-col>
        </v-row>

        <v-row
          v-for="n in 6"
          :key="'players_' + n"
          class="elevation-2 px-2 py-0 text-center"
          align="center"
        >
          <v-col
            cols="6"
            sm="2"
            class="body-1 text-center text-sm-left order-0 order-sm-0"
          >
            <span v-if="isSpielfrei(dialogHeimTeam.name) || checkNil(dialogHeimTeam.players) || checkNil(dialogHeimTeam.players[n-1])">-</span>
            <span v-else>
              {{ dialogHeimTeam.players[n-1].name }}
              <br>
              ({{ dialogHeimTeam.players[n-1].heimIndex }} H / {{ dialogHeimTeam.players[n-1].auswIndex }} A)
            </span>
          </v-col>

          <v-col
            cols="6"
            sm="3"
            v-if="!isSpielfrei(dialogHeimTeam.name) && !checkNil(dialogHeimTeam.players) && !checkNil(dialogHeimTeam.players[n-1])"
            class="order-2 order-sm-1"
          >
            <v-row
              justify="center"
              align="start"
              dense
            >
              <v-col
                v-for="(item, index) in dialogHeimIcons"
                :key="'vitalWertHeim'+index"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      :color="dialogHeimTeam.players[n-1][item.name] | getStatusColor"
                      v-on="on"
                    >
                      {{ item.icon }}
                    </v-icon>
                  </template>
                  <span class="text-capitalize">{{ item.name }}</span>
                </v-tooltip>
                <br>
                {{ dialogHeimTeam.players[n-1][item.name] }}
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-else
            cols="6"
            sm="3"
            class="order-2 order-sm-1"
          >
            -
          </v-col>

          <v-col
            cols="6"
            sm="1"
            class="headline font-weight-light py-1 order-4 order-sm-2"
          >
            <span v-if="isSpielfrei(dialogHeimTeam.name) || checkNil(dialogHeimTeam.players) || checkNil(dialogHeimTeam.players[n-1])">
              0
            </span>
            <template v-else>
              <template v-if="isSpielfrei(dialogAuswTeam.name) || checkNil(dialogAuswTeam.players) || checkNil(dialogAuswTeam.players[n-1])">
                <b>{{ dialogHeimTeam.players[n-1].ergebnis }}</b>
              </template>
              <template v-else>
                <span v-if="dialogHeimTeam.players[n-1].ergebnis > dialogAuswTeam.players[n-1].ergebnis">
                  <b>{{ dialogHeimTeam.players[n-1].ergebnis }}</b>
                </span>
                <span v-else-if="dialogHeimTeam.players[n-1].ergebnis < dialogAuswTeam.players[n-1].ergebnis">
                  {{ dialogHeimTeam.players[n-1].ergebnis }}
                </span>
                <span v-else>
                  {{ dialogHeimTeam.players[n-1].ergebnis }}
                </span>
              </template>
            </template>
          </v-col>

          <v-col
            cols="6"
            sm="1"
            class="headline font-weight-light py-1 order-5 order-sm-3"
          >
            <template v-if="isSpielfrei(dialogHeimTeam.name) || checkNil(dialogHeimTeam.players) || checkNil(dialogHeimTeam.players[n-1])">
              <span v-if="isSpielfrei(dialogAuswTeam.name) || checkNil(dialogAuswTeam.players)|| checkNil(dialogAuswTeam.players[n-1])">
                0
              </span>
              <span v-else>
                <b>{{ dialogAuswTeam.players[n-1].ergebnis }}</b>
              </span>
            </template>
            <template v-else>
              <template v-if="isSpielfrei(dialogAuswTeam.name) || checkNil(dialogAuswTeam.players) || checkNil(dialogAuswTeam.players[n-1])">
                0
              </template>
              <template v-else>
                <span v-if="dialogHeimTeam.players[n-1].ergebnis > dialogAuswTeam.players[n-1].ergebnis">
                  {{ dialogAuswTeam.players[n-1].ergebnis }}
                </span>
                <span v-else-if="dialogHeimTeam.players[n-1].ergebnis < dialogAuswTeam.players[n-1].ergebnis">
                  <b>{{ dialogAuswTeam.players[n-1].ergebnis }}</b>
                </span>
                <span v-else>
                  {{ dialogAuswTeam.players[n-1].ergebnis }}
                </span>
              </template>
            </template>
          </v-col>

          <v-col
            cols="6"
            sm="3"
            v-if="!isSpielfrei(dialogAuswTeam.name) && !checkNil(dialogAuswTeam.players) && !checkNil(dialogAuswTeam.players[n-1])"
            class="order-3 order-sm-4"
          >
            <v-row
              justify="center"
              align="stretch"
              dense
            >
              <v-col
                v-for="(item, index) in dialogAuswIcons"
                :key="'vitalWertAusw'+index"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      :color="dialogAuswTeam.players[n-1][item.name] | getStatusColor"
                      v-on="on"
                    >
                      {{ item.icon }}
                    </v-icon>
                  </template>
                  <span class="text-capitalize">{{ item.name }}</span>
                </v-tooltip>
                <br>
                {{ dialogAuswTeam.players[n-1][item.name] }}
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-else
            cols="6"
            sm="3"
            class="order-3 order-sm-4"
          >
            -
          </v-col>

          <v-col
            cols="6"
            sm="2"
            class="body-1 text-center text-sm-right order-1 order-sm-last"
          >
            <span v-if="isSpielfrei(dialogAuswTeam.name) || checkNil(dialogAuswTeam.players) || checkNil(dialogAuswTeam.players[n-1])">
              -
            </span>
            <span v-else>
              {{ dialogAuswTeam.players[n-1].name }}
              <br>
              ({{ dialogAuswTeam.players[n-1].heimIndex }} H / {{ dialogAuswTeam.players[n-1].auswIndex }} A)
            </span>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          @click="modalClose"
        >
          Spielbericht schließen
          <v-icon right class="ml-1">
            mdi-close-outline
          </v-icon>
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const R = require('ramda')

export default {
  name: 'Spielbericht',
  props: {
    dialogHeimTeam: {
      type: Object,
      default: function () {
        return {
          name: '',
          players: [],
          ergebnis: 0,
          id: 0
        }
      }
    },
    dialogAuswTeam: {
      type: Object,
      default: function () {
        return {
          name: '',
          players: [],
          ergebnis: 0,
          id: 0
        }
      }
    }
  },
  data: function () {
    return {
      dialogHeimIcons: [
        { name: 'kraft', icon: 'mdi-dumbbell' },
        { name: 'motivation', icon: 'mdi-brain' },
        { name: 'technik', icon: 'mdi-webcam' },
        { name: 'kondition', icon: 'mdi-heart-pulse' }
      ],

      dialogAuswIcons: [
        { name: 'kondition', icon: 'mdi-heart-pulse' },
        { name: 'technik', icon: 'mdi-webcam' },
        { name: 'motivation', icon: 'mdi-brain' },
        { name: 'kraft', icon: 'mdi-dumbbell' }
      ]
    }
  },
  methods: {
    modalClose: function () {
      this.$store.commit('saisonStore/SAISON_SET_MODAL_OPEN', false)
    },
    checkNil: function (value) {
      return R.isNil(value)
    },
    isSpielfrei: function (value) {
      // get spielfrei
      return !!((R.isEmpty(value) || R.isNil(value)))
    },
    showLogo: function (teamId) {
      if (!teamId) return ''
      return this.$store.getters['saisonStore/getLogo'](teamId)
    }
  }
}
</script>
